import { setDesignColorSpaceAction as setDesignColorSpaceOperation } from '../slice';

export default setDesignColorSpaceOperation;
